import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IoIosAdd } from 'react-icons/io';

import { useCollections } from '@mssgme/hooks';
import { SidebarHeader, ScrollableBox, NavBackButton, Feature } from '@mssgme/ui';

import { PageLayout } from '../../../../UI';
import { AdminHeaderSearch, CollectionsListDraggable, FilterMessage } from '../UI';

import styles from './PageProductsCollections.scss';

export default function PageProductsCollections() {
    const [filter, setFilter] = useState({ name: '' });
    const collections = useCollections();
    const collectionsWithoutDefault = collections.items.filter((col) => !col.default);
    const collectionsItems = filter.name
        ? collectionsWithoutDefault.filter((col) => col.name.toLowerCase().includes(filter.name.toLowerCase()))
        : collectionsWithoutDefault;
    const { t } = useTranslation('cards');

    const leftButton = <NavBackButton to="/p/products" />;
    const rightButton = (
        <div className={styles.headerBtns}>
            <Link
                className={styles.headerLink}
                to="/p/products/collections/new"
                title={t('PageProductCollections.tipAddCollection')}
            >
                <IoIosAdd size={34} color="#000" />
            </Link>
        </div>
    );

    return (
        <PageLayout className={styles.root}>
            <SidebarHeader
                heading={t('PageProductsMain.collections')}
                leftButton={leftButton}
                rightButton={rightButton}
                style={{ boxShadow: 'none' }}
            />
            <ScrollableBox nopadding>
                <Feature rule="collections:view">
                    <AdminHeaderSearch onChange={(e) => setFilter({ name: e.target.value })} value={filter.name} />
                    <div>
                        {collectionsItems.length > 0 && (
                            <CollectionsListDraggable
                                collections={collectionsItems}
                                draggable
                                isFetching={collections.isFetching}
                            />
                        )}
                        {collectionsItems.length === 0 && filter.name && (
                            <FilterMessage
                                title={t('PageProductCollections.filterEmptyHeading')}
                                description={t('PageProductCollections.filterEmptyDescription')}
                            />
                        )}
                        {collectionsItems.length === 0 && !filter.name && (
                            <FilterMessage
                                title={t('PageProductCollections.emptyTitle')}
                                description={t('PageProductCollections.emptyDescription')}
                            />
                        )}
                    </div>
                </Feature>
            </ScrollableBox>
        </PageLayout>
    );
}
